export default __webpack_public_path__ + "b4fe72ec598541bc9ec3cc5c5384637c.png";